import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appInstance = { billing: '_billingInfo' };
var _billingInfo = { freeTrialInfo: '_freeTrialInfo' };
var _freeTrialInfo = { endDate: 'google.protobuf.Timestamp' };
var _getAppInstanceByInstanceIdRequest = {};
var _getAppInstanceRequest = {};
var _getAppInstanceResponse = { instance: '_appInstance' };
function resolveComWixpressMarketAimApiAppInstanceServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-instance-manager-webapp',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
            {
                srcPath: '/api/v1/instance',
                destPath: '/v1/instance',
            },
            {
                srcPath: '/api/v1/scripts',
                destPath: '/v1/scripts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves data about the instance of your app that's installed on the Wix
 * site and the site itself.
 *
 *
 * You don't have to explicitly pass an identifier for the Wix site as part of
 * the request, since this information is taken automatically from the context.
 *
 * In case you want `site.ownerInfo` to be included in the response, you must
 * have the __Read Site Owner Email__ permission scope in addition to
 * __WIX_DEVELOPERS.MANAGE_APP_INSTANCE__.
 */
export function getAppInstance(payload) {
    var _a = serializer(_getAppInstanceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppInstanceResponse, {
        _appInstance: _appInstance,
        _billingInfo: _billingInfo,
        _freeTrialInfo: _freeTrialInfo,
    }).fromJSON;
    function __getAppInstance(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_instance.v1.app_instance',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.AppInstanceService.GetAppInstance',
            url: resolveComWixpressMarketAimApiAppInstanceServiceUrl({
                protoPath: '/v1/instance',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppInstance.fromReq = fromReq;
    __getAppInstance.__isAmbassador = true;
    return __getAppInstance;
}
export function getAppInstanceByInstanceId(payload) {
    var _a = serializer(_getAppInstanceByInstanceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppInstanceResponse, {
        _appInstance: _appInstance,
        _billingInfo: _billingInfo,
        _freeTrialInfo: _freeTrialInfo,
    }).fromJSON;
    function __getAppInstanceByInstanceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.app_instance.v1.app_instance',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.AppInstanceService.GetAppInstanceByInstanceId',
            url: resolveComWixpressMarketAimApiAppInstanceServiceUrl({
                protoPath: '/v1/instance/{instanceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppInstanceByInstanceId.fromReq = fromReq;
    __getAppInstanceByInstanceId.__isAmbassador = true;
    return __getAppInstanceByInstanceId;
}
//# sourceMappingURL=http.impl.js.map